import {Theme} from '@material-ui/core'
import {createStyles} from '@material-ui/core/styles'

const EEGSummaryReportStyle = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
    },
    topRoot: {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
      },
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    topNav: {
      width: '100%',
      height: 72,
      borderBottom: '1px solid #CECECE',
      boxShadow: '0px 2px 8px 0px #00000014',
      display: 'flex',
      justifyContent: 'space-between',
      background: '#fff',
      marginBottom: 65,
    },
    topNavLeft: {display: 'flex', alignItems: 'center'},
    logo: {marginRight: 20},
    tabs: {display: 'flex', alignItems: 'center', fontFamily: 'Noto Sans KR'},
    heathTabs: {
      display: 'flex',
      fontFamily: 'Noto Sans KR',
      marginBottom: '20px',
    },
    heathTab: {
      border: '2px solid #a7a7a7',
      cursor: 'pointer',
      marginRight: 5,
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      fontWeight: 600,
      minWidth: 200,
      fontSize: '16px',
      padding: '0 18px',
      backgroundColor: '#F4F4F7',
    },
    heathTabActive: {
      color: '#ffffff',
      border: '2px solid #00A29C',
      backgroundColor: '#00A29C',
      fontWeight: 700,
    },
    tab: {
      height: 72,
      fontWeight: 400,
      fontSize: 16,
      color: '#333333',
      display: 'flex',
      alignItems: 'center',
      marginRight: 10,
      padding: '0 18px',
      cursor: 'pointer',
    },
    tabActive: {
      color: '#00A29C',
      borderBottom: '3px solid #00A29C',
      fontWeight: 700,
    },
    topNavRight: {
      display: 'flex',
      alignItems: 'center',
    },
    searchSelect: {
      minWidth: 123,
      height: 72,
      borderRadius: 0,
      '& .MuiSelect-select': {
        padding: '0 20px',
        height: '25px',
      },
      '& fieldset': {
        borderTop: '0 !important',
        borderBottom: '0 !important',
        borderRight: '1px solid #E0E0E0 !important',
        borderLeft: '1px solid #E0E0E0 !important',
      },
      '& svg': {
        right: 12,
      },
    },
    hrvError: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: '#FAFAFA',
      minHeight: 200,
      width: '100%',
      fontSize: 18,
      fontWeight: 700,
    },
  })

export default EEGSummaryReportStyle
